import { SearchWithFilter } from "components/search";

const TekstligeResultatverdierPage = () => {
  return <SearchWithFilter />;
};

export default TekstligeResultatverdierPage;
